import * as React from 'react';
import { useSelector } from 'react-redux';
import { SeoMortgageLink as SeoMortgageLinkComponent } from '../../components/SeoMortgageLink';
import { mortgageSeoPageUrlSelector } from '../../selectors/seoPages';
import { EMortgageOffersTabs } from '../../types/mortgageOffers';
import { trackMortgageOffersTabClick } from '../MortgageSection/tracking';

export const SeoMortgageLink = () => {
  const url = useSelector(mortgageSeoPageUrlSelector);

  const onClick = React.useCallback(() => {
    trackMortgageOffersTabClick(EMortgageOffersTabs.SeoUrl);
  }, []);

  return (
    <SeoMortgageLinkComponent
      url={url}
      onClick={onClick}
      title="Ипотечные предложения и аккредитованные банки"
      testId="seo_mortgage_link"
    />
  );
};
